export const GRADE_TYPE = "UP FOR RENEWAL";
